<template>
  <main class="sitemap">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">サイト情報</h1>
        </div>
      </div>

    <section class="tagJumpTarget" id="Sitemap">
      <div class="areaH2">
        <h2>Sitemap</h2>
      </div>
        <div class="rowView">
        <ul class="sitemapList">
          <li>
<router-link to="/" class="pageLink"><dl><dt>Home</dt>
<dd></dd></dl></router-link>
          </li>
          <li class="">
<router-link to="/policy" class="pageLink"><dl><dt>会社方針</dt>
<dd>企業理念及び代表挨拶、社会貢献活動を掲載しています。</dd></dl></router-link>
          </li>
          <li class="">
<router-link to="/business" class="pageLink"><dl><dt>業務内容</dt>
<dd>当社の業務内容と主業務である精密板金加工について説明します。</dd></dl></router-link>
            <ul>
						<li class="">
<router-link to="/business/equipment?list=1" class="pageLink"><dl><dt>設備一覧</dt>
<dd>本社工場、および城南島工場に設置機器の一覧です。</dd></dl></router-link>
              </li>
							<li class="">
<router-link to="/business/material?list=1" class="pageLink"><dl><dt>取扱素材</dt>
<dd>取り扱う素材の一覧です。</dd></dl></router-link>
              </li>
            </ul>
          </li>
          <li>
<router-link to="/products?list=1" class="pageLink"><dl><dt>製作事例</dt>
<dd>近々の掲載可能なもの載せています。</dd></dl></router-link>
          </li>
          <li>
<router-link to="/deal" class="pageLink"><dl><dt>お見積もり</dt>
<dd>製作ご依頼に関する情報、お見積り、工程など説明します。</dd></dl></router-link>
          </li>
          <li>
<router-link to="/about" class="pageLink"><dl><dt>会社情報</dt>
<dd>概要、沿革、マップを掲載しています。</dd></dl></router-link>
            <ul>
              <li>
<router-link to="/about/announcement?list=1" class="pageLink"><dl><dt>お知らせ</dt>
<dd>当社からのお知らせを掲載します。</dd></dl></router-link>
              </li>
              <li>
<router-link to="/about/official?list=1" class="pageLink"><dl><dt>公式文章一覧</dt>
<dd>当社公式報告書、規定書などのを掲載します。</dd></dl></router-link>
              </li>
            </ul>
          </li>
          <li>
<router-link to="/recruit" class="pageLink"><dl><dt>採用情報</dt>
<dd>当社募集採用内容です。</dd></dl></router-link>
          </li>
          <li>
<router-link to="/customer" class="pageLink"><dl><dt>お客様窓口</dt>
<dd>お客様やり取り用のコーナーです。</dd></dl></router-link>
            <ul>
              <li>
<router-link to="/customer/contact" class="pageLink"><dl><dt>お問い合わせフォーム</dt>
<dd>お客様お問い合わせ用フォームです。製作に関すること、会社に関すること、採用など質問はここからお願いいたします。</dd></dl></router-link>
              </li>
            </ul>
          </li>
          <li>
<router-link to="/sitemap" class="anchorLink"><dl><dt>サイト情報</dt>
<dd>このホームページに関する情報です。</dd></dl></router-link>
            <ul>
              <li>
<a @click="smoothScroll('Sitemap')" class="anchorLink">
<dl><dt>サイトマップ</dt>
<dd>サイトページ一覧です。</dd></dl>
</a>
              </li>
              <li>
<a @click="smoothScroll('PrivacyPolicy')" class="anchorLink">
<dl><dt>個人情報保護方針</dt>
<dd></dd></dl>
</a>
              </li>
              <li>
<a @click="smoothScroll('License')" class="anchorLink">
<dl><dt>ライセンス</dt>
<dd></dd></dl>
</a>
              </li>
						</ul>
          </li>
        </ul>
      </div>
    </section>

  <section class="tagJumpTarget" id="PrivacyPolicy">
        <div class="areaH2">
          <h2>個人情報保護方針</h2>
        </div>
      <div class="rowView">
<h3>個人情報の利用目的</h3>
<p>
当サイトでは、お問い合わせの際、名前やメールアドレスなどの個人情報を入力いただきます。<br>
取得した個人情報は、お問い合わせに対する回答や必要な情報をメールなどでご連絡する場合に利用させていただくものであり、これらの目的以外では使用いたしません。
</p>

<h3>アクセス解析ツールについて</h3>
<p>
当サイトでは、Googleによるアクセス解析ツール「Googleアナリティクス」を使用しています。このGoogleアナリティクスはデータの収集のためにCookieを使用しています。このデータは匿名で収集されており、個人を特定するものではありません。<br>
この機能はCookieを無効にすることで収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。<br>
この規約に関しての詳細は<a href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank" class="externalLink">Googleアナリティクスサービス利用規約</a>のページや<a href="https://policies.google.com/technologies/ads?hl=ja" target="_blank" class="externalLink">Googleポリシーと規約ページ</a>をご覧ください。
</p>

<h3>問い合わせフォームについて</h3>
<p>
当サイトの問い合わせフォームは記載内容をメールで受け取り、個人情報をサーバー内に再利用する形で保持することはありません。<br>
また、受け取ったメール内情報は「個人情報の利用目的」に沿った利用のみとなります。
</p>
			</div>
		</section>

    <section class="tagJumpTarget areaSitemapLicense" id="SitemapLicense">
      <div class="areaH2">
          <h2>ライセンス</h2>
      </div>
        <div class="rowView" id="LicensePicture">
					<h3>使用素材/プログラム</h3>
					<p>
このサイトで使用した素材、プログラムなどの権利・商標を記載します。
					</p>
        <ul class="">
						<li>
<a href="https://pixabay.com/ja/users/garten-gg-201217/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=5226233" rel="nofollow" class="externalLink">G.C.</a>による<a href="https://pixabay.com/ja//?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=5226233"  rel="nofollow" class="externalLink">Pixabay</a>からの画像
						</li>
        </ul>
    </div>
<!--
        <div class="rowView" id="LicensePicture">
					<h3>Web制作</h3>
        <ul class="">
						<li>
<a href="https:rocked.tokyo" class="externalLink" target="_blank">Rocked</a>
						</li>
        </ul>
    </div>
-->
  </section>

    <section class="areaSitemapOthers" id="SitemapOthers">
        <div class="rowView">
<dl>
<dt>制作・運用協力</dt><dd><a href="https:rocked.tokyo" class="externalLink" target="_blank">Rocked</a></dd>
</dl>
				</div>
		</section>

		</div><!--container-->
  </main>
</template>

<script>
export default {
  name: 'sitemap',
  components:{
  },
  data: function () {
    return {
			pageTitle:"サイト情報",
			description:"豊嶋精密工業株式会社サイト内容及び構築、運用の情報です。",
			keywords:"サイトマップ 個人情報保護法 ライセンス",
			ogType:"article",
    }
  },
  mounted: function() {
//インナーナビ情報通知
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
//背景通知
    this.$store.commit('updatePageBackgroundStyle', '')

		this.changePageScrollAnchor()

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', '')
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
  },
  updated: function() {
//インナーナビ情報通知
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
//背景通知
    this.$store.commit('updatePageBackgroundStyle', '')
  },
	methods: {
		stopMouseEvent:function(event) {
			event.target.parentElement.parentElement.style.pointerEvents = "none"
		},
		deleteStopEvent:function(event) {
			event.target.parentElement.parentElement.style.pointerEvents = "auto"
		},
	},
}
</script>

<style>
</style>